var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.4263,
    cy: 32,
    r: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7526 21.9023H42.126L34.756 30.3258L43.4263 41.7883H36.6375L31.3203 34.8364L25.2362 41.7883H21.8607L29.7437 32.7784L21.4263 21.9023H28.3874L33.1937 28.2567L38.7526 21.9023ZM37.5686 39.7691H39.4379L27.3717 23.8155H25.3657L37.5686 39.7691Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitex);
export default __webpack_public_path__ + "static/media/invite x.f97023c43d9aa92b70ce9e67024dc23c.svg";
export { ForwardRef as ReactComponent };